import { identityApiRef, useApi } from '@backstage/core-plugin-api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { customAlertApiRef } from '@agilelab/plugin-wb-platform';
import {
  SystemPrototype,
  systemPrototypeApiRef,
} from '@agilelab/plugin-wb-system-prototype-common';
import { SYSTEM_PROTOTYPES_QUERY_KEY } from './constants';

export const useUpdateSystemPrototype = () => {
  const systemPrototypeApi = useApi(systemPrototypeApiRef);
  const alertApi = useApi(customAlertApiRef);
  const identityApi = useApi(identityApiRef);

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: {
      id: number;
      data: Partial<SystemPrototype>;
    }) => {
      return systemPrototypeApi.updateSystemPrototype(
        params.id,
        params.data,
        await identityApi.getCredentials(),
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [SYSTEM_PROTOTYPES_QUERY_KEY],
      });

      alertApi.post({
        severity: 'success',
        message: 'Prototype updated successfully',
      });
    },
    onError: e => {
      alertApi.post({
        severity: 'error',
        message: (e instanceof Error ? e : new Error('Something went wrong'))
          .message,
      });
    },
  });
};
